module.exports = __webpack_public_path__ + "static/img/memory4.5f39bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memory4.jpg
// module id = MQ+J
// module chunks = 1